export const BNK_STMT_updatebsApprovedReducer = {
  BNK_STMT_updatebsApproved: (state, action) => {
    state.bsApproved = action.payload;
  },
};
